import { IconAds, IconFunnel, IconHome, IconOrders, IconProducts, IconSettings } from "../assets/icons/icons.jsx";
import { Bot, createLucideIcon } from "lucide-react";

// Definición oficial de Lucide `chart-no-axes-combined`. La versión de
// lucide-react que usa esta app aún no exporta el alias, pero sí su fábrica;
// conservar aquí sus nodos exactos evita actualizar toda la librería visual o
// dibujar una aproximación diferente al icono pedido.
const ChartNoAxesCombined = createLucideIcon("ChartNoAxesCombined", [
  ["path", { d: "M12 16v5", key: "1ub0nd" }],
  ["path", { d: "M16 14v7", key: "1g90b9" }],
  ["path", { d: "M20 10v11", key: "1q0qf8" }],
  ["path", { d: "m22 3-8.646 8.646a.5.5 0 0 1-.708 0L9.354 8.354a.5.5 0 0 0-.707 0L2 15", key: "1fwcjo" }],
  ["path", { d: "M4 18v3", key: "1yp0dc" }],
  ["path", { d: "M8 14v7", key: "1tg1ms" }],
]);

type MenuItemOptions = {
  financeEnabled?: boolean;
  chatbotEnabled?: boolean;
};

export const getMenuItems = ({ financeEnabled = false, chatbotEnabled = false }: MenuItemOptions = {}) => [
  {
    path: "/home",
    icon: (active: boolean) => (
      <IconHome color={active ? "#0A0A0A" : "#707070"} />
    ),
    text: "home",
    section: "main",
    disabled: false,
    onClick: () => window.location.href = "/home",
  },
  {
    path: "/orders",
    icon: (active: boolean) => (
      <IconOrders color={active ? "#0A0A0A" : "#707070"} />
    ),
    text: "orders",
    section: "main",
    disabled: false,
    onClick: () => window.location.href = "/orders",
  },
  {
    path: "/products",
    icon: (active: boolean) => (
      <IconProducts color={active ? "#0A0A0A" : "#707070"} />
    ),
    text: "products",
    section: "main",
    disabled: false,
    onClick: () => window.location.href = "/products",
  },
  ...(import.meta.env.VITE_DISABLED_ADS !== "true"
    ? [
        {
          path: "/ads",
          icon: (active: boolean) => (
            <IconAds color={active ? "#0A0A0A" : "#707070"} />
          ),
          text: "ads",
          section: "main",
          disabled: false,
          onClick: () => (window.location.href = "/ads"),
        },
      ]
    : []),
  {
    path: "/funnels",
    icon: (active: boolean) => (
      <IconFunnel color={active ? "#0A0A0A" : "#707070"} />
    ),
    text: "funnels",
    section: "main",
    disabled: false,
    onClick: () => window.location.href = "/funnels",
  },
  ...(financeEnabled
    ? [
        {
          path: "/finance",
          icon: (active: boolean) => (
            <ChartNoAxesCombined className="size-5 ml-[3px]" color={active ? "#0A0A0A" : "#707070"} strokeWidth={1.9} />
          ),
          text: "metrics",
          section: "main",
          disabled: false,
          onClick: () => window.location.href = "/finance",
        },
      ]
    : []),
  ...(chatbotEnabled
    ? [
        {
          path: "/chatbot",
          icon: (active: boolean) => (
            <Bot className="size-5 ml-[3px]" color={active ? "#0A0A0A" : "#707070"} />
          ),
          text: "Chatbot",
          section: "main",
          disabled: false,
          onClick: () => window.location.href = "/chatbot",
        },
      ]
    : []),
  {
    path: "/settings",
    icon: (active: boolean) => (
      <IconSettings color={active ? "#0A0A0A" : "#707070"} />
    ),
    text: "settings",
    section: "settings",
    disabled: false,
    onClick: () => window.location.href = "/settings",
  },
];
